
/* eslint-disable */
// @ts-nocheck
// @ts-ignore

import * as srvoption from './srvoption.proto';


export const enum MsgSystemType {
  MsgSystemTypeUnknown = 0,
  MsgSystemTypeBlockMsg = 1,
  MsgSystemTypeAdminChangeSystemMsg = 2,
  MsgSystemTypeGroupExitMemberOnlyAdmin = 3,
  MsgSystemTypeGroupCollectorPic = 4,
  MsgSystemTypeGroupDissolveApply = 5,
  MsgSystemTypeGroupDissolveCancel = 6,
  MsgSystemTypeGroupDissolveTransfer = 7,
  MsgSystemTypeGroupDissolved = 8,
  MsgSystemTypeGroupDirectTransfer = 9,
  MsgSystemTypeChannelNotice = 10,
  MsgSystemTypeGroupNickNameRuleSet = 11,
  MsgSystemTypeDelChan = 12,
  MsgSystemTypeC2CInviteRegister = 13,
  MsgSystemTypeGroupAccusedDissolved = 14,
  MsgSystemTypeAccusedDelChan = 15,
}

export interface CommonSystemMsg {
  /** 内容 */
  content: string;
  /** 扩展参数,透传给终端 */
  extendParams: Record<string, string>;
  /** 内容模板 */
  contentTemplate: string;
}

export interface CommonSystemPicMsg {
  /** 内容 */
  content: string;
  /** 左图 */
  leftPic: string;
  /** 右图 */
  rightPic: string;
  /** 跳转链接 */
  jumpUrl: string;
  /** 扩展参数,透传给终端 */
  extendParams: Record<string, string>;
  /** 内容模板 */
  contentTemplate: string;
}
